import * as React from 'react'
import { Action, any, async, fromJSX, stateful } from 'widgets-for-react'
import { TaxesOverviewLayout } from './taxesLayout'
import {
  CollectiveWithTariff,
  initialState,
  Props,
  State,
  taxesOverviewUpdaters
} from './taxesState'

export class TaxesOverview extends React.Component<Props> {
  render() {
    return (
      <>
        {stateful<State>({ key: 'taxes-overview' })(s0 =>
          any<Action<State>>()([
            async<CollectiveWithTariff[]>()(s0.overview).map(a =>
              taxesOverviewUpdaters.onOverviewUpdate(a)
            ),
            fromJSX(setState => (
              <TaxesOverviewLayout
                originalProps={this.props}
                state={s0}
                chooseFocus={focusedInput =>
                  setState(
                    taxesOverviewUpdaters.dateRangeUpdaters.onFocusChange(
                      focusedInput
                    )
                  )
                }
                chooseRange={range =>
                  setState(
                    taxesOverviewUpdaters.dateRangeUpdaters.onDatesChange(range)
                  )
                }
              />
            ))
          ]).map(a => a(s0))
        )(initialState(this.props)).run(_ => {})}
      </>
    )
  }
}
